// General
import "./elite-app-button.scss";
import { useEffect } from "react";
// Services
import { useLazyGetProfileQuery } from "../../../../services/data.service";
// Static Data
import userConst from "../../../../const/userConst";
import routeConst from "../../../../const/routeConst";
// Material UI
import { ButtonBase } from "@mui/material";
// i18next
import { useTranslation } from "react-i18next";
// Custom Hooks
import AssetManager from "../../../utility/manager/asset-manager/asset-manager";

const EliteAppButton = () => {
  // API variables
  const [
    getProfile,
    {
      data: getProfileData,
      error: getProfileErrorData,
      isFetching: getProfileFetching,
      isLoading: getProfileLoading,
      isSuccess: getProfileSuccess,
      isError: getProfileError,
    },
  ] = useLazyGetProfileQuery();

  // i18next variables
  const { t } = useTranslation();

  // Custom Hooks Functions
  const getAsset = AssetManager();

  // Lifecycle | Mounted
  useEffect(() => {
    getProfile(null, true);
  }, []);

  // Event Handlers | Button
  const onOpenPage = () => {
    window.open(
      `${routeConst.eliteApp.eliteButtonInvitePath}?p=pwa&u=${getProfileData?.data?.id_int}`,
      "_blank"
    );
  };

  return (
    <ButtonBase id="elite-app-button" component="div" onClick={onOpenPage}>
      <img
        className="elite-app-blank-image"
        src={getAsset(
          getProfileData?.data?.role === userConst?.userRole?.sugarbaby ||
            getProfileData?.data?.role === userConst?.userRole?.maleSugarbaby
            ? "eliteAppBlankBadge"
            : "eliteAppBlankLongBadgeV2"
        )}
      />
      <div
        className={
          getProfileData?.data?.role === userConst?.userRole?.sugarbaby ||
          getProfileData?.data?.role === userConst?.userRole?.maleSugarbaby
            ? "sb-label"
            : "sd-label"
        }
      >
        {t(
          getProfileData?.data?.role === userConst?.userRole?.sugarbaby ||
            getProfileData?.data?.role === userConst?.userRole?.maleSugarbaby
            ? "misc.elite_app_sb_description"
            : "misc.elite_app_sd_description"
        )}
      </div>
    </ButtonBase>
  );
};

export default EliteAppButton;
